import { GridFilterItem, GridSortDirection } from "@mui/x-data-grid";

export type QueryBuilderOperator = "=" | ">" | ">=" | "<" | "<=" | "<>";

export class UrlBuilder {
  page: number | null = null;
  perPage: number | null = null;
  path = "";
  filters: { [filterName: string]: string[] } = {};
  sorting: { field: string; sort: GridSortDirection }[] = [];
  include: string[] = [];
  gridFilterItems: GridFilterItem[] = [];

  constructor(path: string) {
    this.path = path;
  }

  setPage(page: number | null | undefined) {
    if (page !== undefined) {
      this.page = page;
    }
    return this;
  }

  setPerPage(perPage: number | null | undefined) {
    if (perPage !== undefined) {
      this.perPage = perPage;
    }
    return this;
  }

  addInclude(relationship: string | string[] | undefined) {
    if (relationship !== undefined) {
      if (Array.isArray(relationship)) {
        this.include = this.include.concat(relationship);
      } else {
        this.include.push(relationship);
      }
    }
    return this;
  }
  addFilter(filterName: string, value?: string | number | string[] | number[], operator?: QueryBuilderOperator) {
    if (value !== undefined) {
      if (this.filters[filterName] == null) {
        this.filters[filterName] = [];
      }
      let filterValue = Array.isArray(value) ? value.join("," + operator) : String(value);

      if (operator !== undefined) {
        filterValue = operator + filterValue;
      }

      this.filters[filterName].push(filterValue);
    }
    return this;
  }

  setSorting(sorting?: { field: string; sort: GridSortDirection }[]) {
    if (sorting !== undefined) {
      this.sorting = sorting;
    }
    return this;
  }

  setFilters(gridFilterItems?: GridFilterItem[]) {
    if (gridFilterItems !== undefined) {
      this.gridFilterItems = gridFilterItems;
    }
    return this;
  }

  get url() {
    let url = "/" + this.path + "?";
    Object.keys(this.filters).forEach((filterName) => {
      this.filters[filterName].forEach((value) => {
        url += `filter[${filterName}]=${value}&`;
      });
    });

    this.gridFilterItems.forEach((gridFilterItem) => {
      const value = Array.isArray(gridFilterItem.value) ? gridFilterItem.value.join(",") : gridFilterItem.value;
      url += `filter[${gridFilterItem.field}]=${value}&`;
    });

    const include = this.include.join(",");

    if (include && include.length > 0) {
      url += `include=${include}&`;
    }
    if (this.page != null) {
      url += `page=${this.page}&`;
    }
    if (this.perPage != null) {
      url += `per_page=${this.perPage}&`;
    }

    if (this.sorting) {
      url += `sort=` + this.sorting.map(({ field, sort }) => (sort === "asc" ? field : "-" + field)) + "&";
    }

    return url;
  }
}
